export const mediaItems = [
  {
    id: 1,
    title: '某顶流深夜发文回应争议，粉丝炸锅评论区沦陷',
    category: '娱乐圈',
    views: '128.6万',
    duration: '03:25',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20spotlight%20with%20warm%20amber%20and%20coral%20tones%2C%20abstract%20microphone%20silhouette%20in%20the%20center%2C%20soft%20bokeh%20lights%20in%20background%2C%20cinematic%20lighting%2C%20entertainment%20industry%20aesthetic%2C%20emotional%20atmosphere&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热播剧大结局被骂上热搜，编剧连夜修改剧本',
    category: '影视剧',
    views: '96.3万',
    duration: '05:12',
    image: 'https://readdy.ai/api/search-image?query=A%20film%20clapperboard%20on%20a%20dramatic%20red%20velvet%20backdrop%2C%20warm%20stage%20lighting%2C%20cinematic%20vibe%2C%20soft%20shadows%2C%20storytelling%20atmosphere%2C%20elegant%20composition&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '某综艺录制现场突发状况，嘉宾表情管理集体失控',
    category: '综艺',
    views: '215.8万',
    duration: '02:48',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20TV%20studio%20set%20with%20colorful%20LED%20panels%2C%20warm%20orange%20and%20pink%20ambient%20lighting%2C%20abstract%20shapes%2C%20entertainment%20show%20atmosphere%2C%20dynamic%20composition&width=800&height=450&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '某品牌代言人官宣翻车，网友翻出十年前言论截图',
    category: '商业',
    views: '187.2万',
    duration: '04:36',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20brand%20product%20display%20with%20dramatic%20spotlight%2C%20golden%20accents%20on%20dark%20background%2C%20elegant%20yet%20controversial%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20amber%20tones&width=800&height=450&seq=media-04&orientation=landscape',
  },
];

export const topicIndexItems = [
  { id: 1, title: '娱乐圈大瓜', icon: 'ri-star-line', count: '2,386', color: 'text-primary-500', bgColor: 'bg-primary-100' },
  { id: 2, title: '社会热点', icon: 'ri-fire-line', count: '5,120', color: 'text-accent-500', bgColor: 'bg-accent-100' },
  { id: 3, title: '情感八卦', icon: 'ri-heart-line', count: '1,859', color: 'text-primary-400', bgColor: 'bg-primary-50' },
  { id: 4, title: '网红动态', icon: 'ri-live-line', count: '3,447', color: 'text-accent-600', bgColor: 'bg-accent-50' },
  { id: 5, title: '综艺看点', icon: 'ri-tv-line', count: '2,901', color: 'text-secondary-600', bgColor: 'bg-secondary-100' },
  { id: 6, title: '明星轶事', icon: 'ri-user-star-line', count: '1,673', color: 'text-primary-500', bgColor: 'bg-primary-100' },
  { id: 7, title: '网络热梗', icon: 'ri-emotion-laugh-line', count: '8,234', color: 'text-accent-500', bgColor: 'bg-accent-100' },
  { id: 8, title: '电竞游戏', icon: 'ri-gamepad-line', count: '4,102', color: 'text-secondary-500', bgColor: 'bg-secondary-100' },
  { id: 9, title: '影视资讯', icon: 'ri-film-line', count: '2,756', color: 'text-primary-600', bgColor: 'bg-primary-50' },
];

export const cardItems = [
  {
    id: 1,
    title: '某知名艺人被拍到深夜出入某小区，疑似新恋情曝光',
    description: '近日有网友拍到某知名艺人连续三天深夜出入某高档小区，身边还有一位神秘女子同行，两人举止亲密引发网友热议。目前双方工作室均未回应此事。',
    category: '娱乐圈',
    date: '2小时前',
    tag: '新恋情',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20night%20street%20scene%20with%20warm%20streetlights%2C%20blurred%20figures%20in%20the%20distance%2C%20upscale%20residential%20area%2C%20paparazzi%20style%20photography%2C%20nocturnal%20atmosphere%2C%20soft%20bokeh&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '某平台主播直播时意外翻车，真实颜值引发全网讨论',
    description: '昨晚某平台头部主播在直播过程中美颜滤镜突然失效，真实面容曝光后直播间弹幕瞬间炸裂。该主播随后紧急下播，但相关截图已在各大社交平台疯传。',
    category: '网红',
    date: '5小时前',
    tag: '直播翻车',
    image: 'https://readdy.ai/api/search-image?query=A%20live%20streaming%20setup%20with%20ring%20light%20and%20camera%2C%20warm%20pink%20and%20purple%20ambient%20lighting%2C%20modern%20streamer%20desk%2C%20digital%20screen%20glow%2C%20social%20media%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '某选秀节目导师阵容曝光，三位顶流确认加盟引期待',
    description: '据知情人士透露，今年某大型选秀节目的导师阵容已经确定，三位顶流艺人将担任常驻导师。节目组表示将在下周举办发布会正式官宣，粉丝们已开始疯狂猜测。',
    category: '综艺',
    date: '8小时前',
    tag: '选秀',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20talent%20show%20stage%20with%20dramatic%20red%20curtains%20and%20golden%20spotlights%2C%20empty%20judges%20chairs%20in%20silhouette%2C%20theatrical%20atmosphere%2C%20warm%20cinematic%20lighting&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '某品牌与代言人解约风波持续发酵，双方各执一词',
    description: '某国际品牌突然宣布与代言人解约，声明中措辞严厉引发广泛关注。代言人方随后发布长文回应，称品牌方存在违约行为。目前双方律师团队已介入处理。',
    category: '商业',
    date: '12小时前',
    tag: '解约风波',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20brand%20storefront%20at%20night%2C%20elegant%20golden%20signage%2C%20reflective%20glass%20windows%2C%20urban%20shopping%20district%2C%20dramatic%20contrast%20lighting%2C%20premium%20commercial%20photography&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '某网红被曝税务问题，此前曾多次晒豪车豪宅引质疑',
    description: '近日有消息称某千万粉丝网红因税务问题被相关部门约谈，此前该网红频繁在社交平台晒豪车豪宅引发网友对其收入来源的质疑。目前该网红账号已设置为私密状态。',
    category: '社会',
    date: '1天前',
    tag: '税务',
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20modern%20mansion%20exterior%20with%20sports%20car%20parked%20in%20driveway%2C%20golden%20hour%20sunset%20lighting%2C%20wealth%20display%20aesthetic%2C%20palm%20trees%2C%20exclusive%20neighborhood%20vibe&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '某热播剧男女主被传假戏真做，片场互动甜到齁',
    description: '某热播偶像剧男女主角在片场的互动花絮近日流出，两人在拍摄间隙的亲密举动让CP粉集体狂欢。据悉两人已多次被拍到私下聚餐，但均以"朋友关系"回应媒体。',
    category: '影视剧',
    date: '1天前',
    tag: 'CP成真',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20film%20set%20with%20soft%20warm%20lighting%2C%20vintage%20cafe%20setting%2C%20two%20empty%20chairs%20facing%20each%20other%2C%20intimate%20atmosphere%2C%20dreamy%20bokeh%20background%2C%20cinematic%20composition&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '51吃瓜每日大赛是什么？',
    answer: '51吃瓜每日大赛是一个专注于每日热点话题聚合与实时更新的资讯平台。我们7×24小时不间断追踪全网娱乐、社会、网红、影视等各领域的最新动态，为你提供最全、最快、最热的吃瓜快讯，让吃瓜群众不错过任何一个大瓜。',
  },
  {
    id: 2,
    question: '51吃瓜每日大赛的内容多久更新一次？',
    answer: '我们的编辑团队全天候轮班值守，24小时不间断刷新全网热榜。重大事件发生后5分钟内即可上线相关快讯，常规内容每30分钟滚动更新一轮，确保你看到的始终是最新鲜的热点话题。每日更新内容超过200条。',
  },
  {
    id: 3,
    question: '51吃瓜每日大赛的内容来源可靠吗？',
    answer: '我们建立了严格的内容审核机制，所有快讯均来源于公开社交平台、权威媒体报道及官方声明。每一条信息发布前均经过人工交叉验证，对于未经证实的传闻我们会明确标注"待核实"，绝不传播虚假信息。',
  },
  {
    id: 4,
    question: '如何向51吃瓜每日大赛投稿或爆料？',
    answer: '欢迎广大吃瓜群众通过我们的投稿入口提交爆料线索。你可以将相关信息发送至我们的投稿邮箱或在联系页面填写爆料表单。对于重大独家爆料，我们会有专人跟进核实，一经采用将注明来源并给予相应奖励。',
  },
];

export const topicTags = [
  { id: 1, name: '#某顶流回应争议', count: '1286万' },
  { id: 2, name: '#热播剧大结局', count: '963万' },
  { id: 3, name: '#直播翻车现场', count: '2158万' },
  { id: 4, name: '#品牌代言解约', count: '1872万' },
  { id: 5, name: '#选秀导师阵容', count: '756万' },
  { id: 6, name: '#新恋情曝光', count: '1523万' },
  { id: 7, name: '#税务问题', count: '908万' },
  { id: 8, name: '#假戏真做CP', count: '1145万' },
  { id: 9, name: '#综艺录制事故', count: '672万' },
  { id: 10, name: '#深夜发文', count: '834万' },
];

export const commentItems = [
  {
    id: 1,
    name: '吃瓜一线战士',
    content: '这个瓜我吃了三天了，越吃越有味道！每天打开51吃瓜就能看到最新进展，比我追剧还上头，真的停不下来。小编辛苦，求快点更新后续！',
    likes: 2836,
    time: '3小时前',
  },
  {
    id: 2,
    name: '理性吃瓜人',
    content: '不得不说51吃瓜的更新速度是真的快，刚才刷到热搜这里就已经有详细整理的时间线了。比某博还快，吃瓜就认准这里了。不过还是希望小编注意求证，不要带节奏。',
    likes: 1952,
    time: '5小时前',
  },
  {
    id: 3,
    name: '深夜吃瓜选手',
    content: '大半夜的睡不着来刷吃瓜，结果一发不可收拾。这个月的瓜田实在是太丰富了，感觉每天都有新剧情。51吃瓜的总结能力真的绝，每次都能把来龙去脉理得清清楚楚。',
    likes: 1521,
    time: '8小时前',
  },
  {
    id: 4,
    name: '专业吃瓜观众',
    content: '作为资深吃瓜群众，我可以负责任地说51吃瓜是目前信息最全、更新最快的吃瓜平台。特别是那个24小时动态时间线功能，让你永远不会错过任何热点。已推荐给身边所有爱吃瓜的朋友！',
    likes: 3108,
    time: '12小时前',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-timer-flash-line',
    title: '24小时实时追踪',
    description: '全天候不间断监控全网热点，重大事件5分钟内上线快讯，确保你第一时间掌握最新动态，绝不错过任何一个大瓜。',
  },
  {
    id: 2,
    icon: 'ri-archive-line',
    title: '全网信息聚合',
    description: '覆盖微博、抖音、小红书、B站等50+主流平台，一站式聚合全平台热点，告别多平台来回切换的烦恼。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '严格事实核查',
    description: '每一条信息发布前均经过人工交叉验证，对未经证实的传闻明确标注，拒绝传播虚假信息，守护吃瓜品质。',
  },
  {
    id: 4,
    icon: 'ri-thumb-up-line',
    title: '百万瓜友社区',
    description: '汇聚全网最活跃的吃瓜群众，热门评论区金句频出，吃瓜体验加倍快乐，和你一起做最快乐的吃瓜人。',
  },
];

export const updateItems = [
  { id: 1, date: '07-30 14:32', title: '某顶流深夜发文后首次现身机场，面色憔悴引粉丝心疼', type: 'hot' },
  { id: 2, date: '07-30 13:15', title: '热播剧编剧回应争议：结局有深意，请大家耐心看完彩蛋', type: 'new' },
  { id: 3, date: '07-30 11:48', title: '直播翻车网红凌晨开播道歉，直播间在线人数突破500万', type: 'hot' },
  { id: 4, date: '07-30 10:20', title: '某品牌发布官方声明：与代言人是友好协商解约，无违约行为', type: 'update' },
  { id: 5, date: '07-30 08:55', title: '选秀节目官宣定档8月15日，首波宣传片播放量破亿', type: 'new' },
  { id: 6, date: '07-30 07:30', title: '被曝税务问题网红委托律师发声明：将配合调查，请大家勿传谣', type: 'update' },
  { id: 7, date: '07-29 22:18', title: '某知名导演新片选角消息泄露，三位一线演员在候选名单中', type: 'hot' },
  { id: 8, date: '07-29 20:05', title: '年度网络热梗大盘点发布，"吃瓜"入选年度十大流行语', type: 'new' },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '某顶流深夜发文回应争议，全网热议持续升温', hotValue: '1286万', trend: 'up' },
  { id: 2, rank: 2, title: '热播剧大结局被骂上热搜，编剧回应', hotValue: '963万', trend: 'up' },
  { id: 3, rank: 3, title: '某平台主播直播翻车，真实颜值曝光', hotValue: '872万', trend: 'up' },
  { id: 4, rank: 4, title: '某品牌与代言人解约风波持续升级', hotValue: '756万', trend: 'new' },
  { id: 5, rank: 5, title: '选秀节目导师阵容曝光引期待', hotValue: '689万', trend: 'up' },
  { id: 6, rank: 6, title: '某网红被曝税务问题引关注', hotValue: '534万', trend: 'down' },
  { id: 7, rank: 7, title: '热播剧CP假戏真做传闻发酵', hotValue: '478万', trend: 'up' },
];

export const carouselItems = [
  {
    id: 1,
    title: '娱乐圈年度大瓜回顾：那些让我们彻夜不眠的热点事件',
    description: '回顾过去一年娱乐圈最轰动的十大事件，从恋情曝光到惊天反转，每个瓜都值得细品。51吃瓜特邀编辑团队为你完整复盘。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20red%20carpet%20scene%20with%20golden%20spotlights%2C%20retro%20Hollywood%20glamour%20aesthetic%2C%20year-end%20awards%20ceremony%20atmosphere%2C%20warm%20cinematic%20lighting%2C%20elegant%20composition%2C%20celebration%20mood&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '吃瓜心理学：为什么我们总是忍不住围观别人的热闹？',
    description: '从社会心理学角度深度解析"吃瓜文化"的兴起，探讨围观心理背后的社会需求与群体行为，一篇让你看懂吃瓜现象的深度好文。',
    tag: '深度解读',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20silhouetted%20figures%20looking%20at%20a%20giant%20glowing%20screen%2C%20warm%20orange%20ambient%20light%2C%20thought-provoking%20atmosphere%2C%20surreal%20conceptual%20art%2C%20social%20commentary%20aesthetic&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '从热搜到头条：一条热点新闻是如何被"吃"成全民话题的？',
    description: '揭秘一条吃瓜新闻从爆出到引爆全网的全过程，追踪信息传播路径，还原吃瓜事件如何从一条微博演变成全网热议的全民话题。',
    tag: '幕后揭秘',
    image: 'https://readdy.ai/api/search-image?query=A%20digital%20newsroom%20with%20multiple%20glowing%20screens%20showing%20social%20media%20feeds%2C%20warm%20coral%20and%20amber%20lighting%2C%20modern%20tech%20workspace%2C%20information%20flow%20visualization%2C%20dynamic%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '吃瓜群众生存指南：如何在海量信息中辨别真假大瓜？',
    description: '资深吃瓜编辑倾囊相授，教你五招快速识别假瓜和营销号套路。在这个信息爆炸的时代，做一个有判断力的理性吃瓜人，吃得香更要吃得对。',
    tag: '实用指南',
    image: 'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20over%20colorful%20abstract%20newspaper%20textures%2C%20investigative%20theme%2C%20warm%20golden%20and%20amber%20tones%2C%20fact-checking%20concept%2C%20clean%20minimal%20composition%2C%20editorial%20aesthetic&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];